module.exports = __webpack_public_path__ + "static/media/26UNRWA13.b1bd34e6.jpg";